<template>
  <div>
    <p v-if="attributes.length === 0">{{ $t('no_atributos') }}</p>

    <table class="table table-striped" v-if="attributes.length > 0">
      <thead>
      <tr>
        <th scope="col">{{ $t('campos_atributos.nombre') }}</th>
        <th scope="col">{{ $t('campos_atributos.etiqueta') }}</th>
        <th scope="col">{{ $t('campos_atributos.descripcion') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="attribute in attributes">
        <th scope="row">{{ attribute.code }}</th>
        <td>{{ attribute[`label_${locale}`] || '-' }}</td>
        <td>{{ attribute[`description_${locale}`] || '-'}}</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>

    export default {
        name: 'AttributesTab',
        props: {
            attributes: {
                type: Array,
                required: true
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
        },
    }
</script>